<template>
    <v-row justify="end" class="ma-0 pa-0">
        <v-dialog
                v-model="dialog"
                hide-overlay
                width="auto "
                :fullscreen="$vuetify.breakpoint.xsOnly"
                transition="dialog-bottom-transition"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="startCase"
                    class="upd-btn ma-0"
                >
                    Submit case
                </v-btn>
            </template>
            <v-card style="min-width: 450px">
                <v-toolbar dark color="primary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Send To Risk Department</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-container class="grey lighten-5" style="padding-left: 10%; padding-right: 10%">
                    <v-row style="margin-top: 10px">
                        <p>Affiliate: {{affiliate.name}}}</p>
                    </v-row>
                    <v-row>
                        <p>Reporter: {{userName}}</p>
                    </v-row>
                    <v-row>
                        <v-select
                                v-model="selectedType"
                                :items="types"
                                item-value="id"
                                item-text="name"
                                label="Risk type"
                        ></v-select>
                    </v-row>
                    <v-row>
                        <v-select
                                v-model="selectedCompany"
                                :items="campaigns"
                                item-value="id"
                                item-text="name"
                                label="Campaign (optional)"
                        ></v-select>
                    </v-row>
                    <v-row>
                        <v-textarea
                                v-model="reason"
                                label="Reason"
                        ></v-textarea>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-btn
                                color="secondary"
                                text
                                @click="close"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                color="primary"
                                text
                                @click="submitCase"
                        >
                            Save
                        </v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import store from "@/store";
    import affiliatesApi from "@/api/affiliates";

    export default {
        data: () => ({
            dialog: false,
            reason: '',
            selectedType: 0,
            selectedCompany: 0,
            types: [{id: 1, name: 'risk'}, {id:2, name: 'policy'}]
        }),
        props: {
            affiliate: Object,
            userName: String,
            campaigns: Array
        },
        async mounted() {

        },
        methods:{
            startCase() {
                this.dialog = true;
            },
            async submitCase() {
                const data = {
                    type: (this.types.find(tp => tp.id === this.selectedType))['name'],
                    companyId: this.selectedCompany || null,
                    affiliateId: this.affiliate.id,
                    reason: this.reason,
                    initiator: this.userName
                };

                try {
                    await affiliatesApi.createCase(data);
                    store.dispatch('alert/ALERT_SUCCESS', `Case has been created`, {root: true});
                } catch (e) {
                    store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
                }

                setTimeout(() => {
                    store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
                }, 3000);


                this.dialog = false;
                this.cleanUp();
            },
            close() {
                this.cleanUp()
            },

            cleanUp() {
                this.dialog = false;
                this.selectedCompany = 0;
                this.selectedType = 0;
                this.reason = '';
            }
        }
    }
</script>

<style scoped lang="sass">
</style>
